const ArrowDownRed = () => (
  <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Vector 339" d="M4.14645 12.8536C4.34171 13.0488 4.65829 13.0488 4.85355 12.8536L8.03553 9.67157C8.2308 9.47631 8.2308 9.15973 8.03553 8.96447C7.84027 8.7692 7.52369 8.7692 7.32843 8.96447L4.5 11.7929L1.67157 8.96447C1.47631 8.7692 1.15973 8.7692 0.964466 8.96447C0.769204 9.15973 0.769204 9.47631 0.964466 9.67157L4.14645 12.8536ZM4 -4.37114e-08L4 12.5L5 12.5L5 4.37114e-08L4 -4.37114e-08Z" fill="#ED6E69" />
  </svg>
);

export default ArrowDownRed;